import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRequestIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 13,
	viewBox: "0 0 14 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11 7L13.5 4L11 1",
			stroke: "#FF3131",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 4L13 4",
			stroke: "#FF3131",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 8L8 8",
			stroke: "#FF3131",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 12L13 12",
			stroke: "#FF3131",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgRequestIcon;
